import React, { useRef } from "react";
import sanitizeHtml, { IOptions } from "sanitize-html";

// https://stackoverflow.com/questions/38663751/how-to-safely-render-html-in-react
const sanitize = (dirty: string, options?: IOptions) => ({
  __html: sanitizeHtml(dirty, (options = { ...options })),
});

function SanitizeHtml(props: ISanitizeHtml) {
  const { html, options, className, setRefDescription } = props;
  const refDescription = useRef<HTMLDivElement>(null);
  if(setRefDescription) {
    setRefDescription(refDescription)
  }
  return <div 
    className={className} 
    dangerouslySetInnerHTML={sanitize(html, options)} 
    ref={refDescription}
  />;
}

interface ISanitizeHtml {
  html: string;
  options?: IOptions;
  className?: string;
  setRefDescription?: any;
}

export default SanitizeHtml;
